module.exports = __webpack_public_path__ + "static/mockup-1aef0d96cc51bab496c57ddbc37000e7.jpg";